import { useState, useEffect, useCallback, useRef, Fragment } from "react";
import api from "../api";

const ORANGE = "#EE6A1A";
const API_ORIGIN = "";

const fmt = (v) => "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const toInput = (d) => { if (!d) return ""; const s = String(d); const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? `${m[1]}-${m[2]}-${m[3]}` : ""; };
const fmtData = (d) => { if (!d) return "—"; const s = String(d); const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? `${m[3]}/${m[2]}/${m[1]}` : "—"; };
function tempoDeCasa(d) {
  if (!d) return "—";
  const a = new Date(d), h = new Date();
  let meses = (h.getFullYear() - a.getFullYear()) * 12 + (h.getMonth() - a.getMonth());
  if (h.getDate() < a.getDate()) meses--;
  if (meses < 0) return "—";
  const anos = Math.floor(meses / 12), m = meses % 12;
  const p = [];
  if (anos) p.push(anos + (anos === 1 ? " ano" : " anos"));
  if (m) p.push(m + (m === 1 ? " mês" : " meses"));
  return p.length ? p.join(" e ") : "menos de 1 mês";
}

const ST_COR = { ativo: "#1D9E75", afastado: "#EBA13A", ferias: "#579bfc", desligado: "#98A2B3" };
const ST_LABEL = { ativo: "Ativo", afastado: "Afastado", ferias: "Férias", desligado: "Desligado" };

const inp = { width: "100%", boxSizing: "border-box", padding: "8px 10px", fontSize: 13, borderRadius: 8, border: "1px solid var(--border-color)", background: "var(--card-bg)", color: "var(--text-primary)", outline: "none" };
const lbl = { fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".04em", marginBottom: 4, display: "block" };
const btn = (cor) => ({ padding: "8px 14px", fontSize: 13, fontWeight: 600, borderRadius: 8, border: "none", cursor: "pointer", background: cor || ORANGE, color: "#fff" });
const btnG = { padding: "8px 14px", fontSize: 13, fontWeight: 600, borderRadius: 8, border: "1px solid var(--border-color)", cursor: "pointer", background: "var(--card-bg)", color: "var(--text-secondary)" };

function Campo({ label, children }) {
  return <div><label style={lbl}>{label}</label>{children}</div>;
}
function KPI({ n, label, cor }) {
  return (
    <div style={{ flex: 1, minWidth: 140, padding: "14px 16px", borderRadius: 12, background: "var(--card-bg)", border: "1px solid var(--border-color)" }}>
      <div style={{ fontSize: 24, fontWeight: 800, color: cor || "var(--text-primary)" }}>{n}</div>
      <div style={{ fontSize: 11.5, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".04em", fontWeight: 600, marginTop: 2 }}>{label}</div>
    </div>
  );
}

export default function RH() {
  const [lista, setLista] = useState([]);
  const [resumo, setResumo] = useState(null);
  const [busca, setBusca] = useState("");
  const [filtro, setFiltro] = useState("todos");
  const [aberto, setAberto] = useState(null);
  const [novo, setNovo] = useState(null);

  const carregar = useCallback(async () => {
    try {
      const [l, r] = await Promise.all([api.get("/colaboradores"), api.get("/colaboradores/resumo")]);
      setLista(Array.isArray(l.data) ? l.data : []);
      setResumo(r.data || null);
    } catch (e) { console.error("Erro RH", e); }
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  const filtrados = lista.filter(c => {
    if (filtro !== "todos" && c.status !== filtro) return false;
    if (busca) { const b = busca.toLowerCase(); return [c.nome, c.cargo, c.departamento, c.cpf].some(x => String(x || "").toLowerCase().includes(b)); }
    return true;
  });

  const ordenados = [...filtrados].sort((a, b) => ((a.status === "desligado") - (b.status === "desligado")));

  const salvarNovo = async (dados) => {
    try { const { data } = await api.post("/colaboradores", dados); setNovo(null); await carregar(); setAberto(data); }
    catch (e) { alert("Erro ao criar: " + ((e.response && e.response.data && e.response.data.erro) || e.message)); }
  };

  const hoje0 = new Date(); hoje0.setHours(0, 0, 0, 0);
  const vencimentos = [];
  lista.forEach(c => (c.documentos || []).forEach(d => {
    if (d.validade) { const v = new Date(d.validade); v.setHours(0, 0, 0, 0); const dias = Math.round((v - hoje0) / 86400000); if (dias <= 60) vencimentos.push({ colab: c, nome: d.nome, categoria: d.categoria, validade: d.validade, dias }); }
  }));
  vencimentos.sort((a, b) => a.dias - b.dias);

  return (
    <div style={{ padding: "24px 28px" }}>
      <div style={{ marginBottom: 18 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800, color: "var(--text-primary)" }}>RH · Colaboradores</h1>
        <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 2 }}>Cadastro, documentos, vales e férias da equipe</div>
      </div>

      {resumo && (
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 20 }}>
          <KPI n={resumo.total} label="Colaboradores" />
          <KPI n={resumo.ativos} label="Ativos" cor="#1D9E75" />
          <KPI n={resumo.admissoesMes} label="Admissões no mês" cor={ORANGE} />
          <KPI n={resumo.aniversariantes} label="Aniversariantes" cor="#579bfc" />
          <KPI n={resumo.docsVencendo} label="Docs a vencer (30d)" cor={resumo.docsVencendo ? "#e2445c" : "var(--text-primary)"} />
          <KPI n={fmt(resumo.folha)} label="Folha estimada" cor="#1D9E75" />
        </div>
      )}

      {vencimentos.length > 0 && (
        <div style={{ marginBottom: 18, padding: 16, borderRadius: 12, border: "1px solid #EBA13A55", background: "#EBA13A12" }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#B4780F", marginBottom: 10 }}>🔔 Vencimentos de documentos (ASO, NRs e afins)</div>
          <div style={{ display: "grid", gap: 6 }}>
            {vencimentos.slice(0, 12).map((x, i) => {
              const vencido = x.dias < 0;
              return (
                <div key={i} onClick={() => setAberto(x.colab)} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", borderRadius: 8, background: "var(--card-bg)", border: "1px solid var(--border-color)", cursor: "pointer" }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text-primary)", minWidth: 180 }}>{x.colab.nome}</span>
                  <span style={{ fontSize: 12.5, color: "var(--text-secondary)", flex: 1, minWidth: 0 }}>{x.nome} <span style={{ color: "var(--text-muted)" }}>· {x.categoria}</span></span>
                  <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{fmtData(x.validade)}</span>
                  <span style={{ fontSize: 10.5, fontWeight: 700, color: vencido ? "#e2445c" : "#B4780F", background: (vencido ? "#e2445c" : "#EBA13A") + "22", borderRadius: 8, padding: "2px 8px", minWidth: 96, textAlign: "center" }}>{vencido ? "Vencido há " + Math.abs(x.dias) + "d" : "Vence em " + x.dias + "d"}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14, flexWrap: "wrap" }}>
        <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por nome, cargo, CPF..." style={{ ...inp, width: 280 }} />
        <select value={filtro} onChange={e => setFiltro(e.target.value)} style={{ ...inp, width: 160, appearance: "auto" }}>
          <option value="todos">Todos os status</option>
          <option value="ativo">Ativos</option>
          <option value="afastado">Afastados</option>
          <option value="ferias">Em férias</option>
          <option value="desligado">Desligados</option>
        </select>
        <span style={{ fontSize: 13, color: "var(--text-muted)" }}>{filtrados.length} colaborador(es)</span>
        <button onClick={() => setNovo({ novo: true, status: "ativo", tipoContrato: "CLT" })} style={{ ...btn(), marginLeft: "auto" }}>+ Novo colaborador</button>
      </div>

      <div style={{ background: "var(--card-bg)", borderRadius: 12, border: "1px solid var(--border-color)", overflow: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "var(--hover-bg)" }}>
              {["Colaborador", "Cargo", "Departamento", "Admissão", "Tempo de casa", "Salário", "Status", ""].map((h, i) => (
                <th key={i} style={{ textAlign: h === "" ? "center" : (h === "Salário" ? "right" : "left"), padding: "10px 14px", fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".04em", whiteSpace: "nowrap" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ordenados.map((c, idx) => {
              const sep = c.status === "desligado" && (idx === 0 || ordenados[idx - 1].status !== "desligado");
              return (
              <Fragment key={c._id}>
              {sep && <tr><td colSpan={8} style={{ padding: "8px 14px", background: "var(--hover-bg)", fontSize: 11, fontWeight: 800, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".05em" }}>Desligados</td></tr>}
              <tr style={{ borderTop: "1px solid var(--border-color)", opacity: c.status === "desligado" ? 0.55 : 1 }}>
                <td style={{ padding: "10px 14px" }}>
                  <div style={{ fontWeight: 700, color: "var(--text-primary)", fontSize: 13.5 }}>{c.nome}</div>
                  {c.email && <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{c.email}</div>}
                  {(() => {
                    if (c.status === "desligado" || !c.dataAdmissao) return null;
                    const _adm = new Date(String(c.dataAdmissao).slice(0,10) + "T12:00:00");
                    if (isNaN(_adm.getTime())) return null;
                    const _hoje = new Date(); _hoje.setHours(12,0,0,0);
                    const _D = 86400000;
                    const _f45 = new Date(_adm.getTime() + 45*_D);
                    const _f90 = new Date(_adm.getTime() + 90*_D);
                    if (_hoje.getTime() > _f90.getTime()) return null;
                    const _alvo = _hoje.getTime() <= _f45.getTime() ? _f45 : _f90;
                    const _rot = _hoje.getTime() <= _f45.getTime() ? "Exp. 45d" : "Exp. 90d";
                    const _dias = Math.ceil((_alvo.getTime() - _hoje.getTime()) / _D);
                    const _venceu = _dias < 0, _perto = _dias <= 10;
                    const _cor = _venceu ? "#e2445c" : _perto ? "#B4780F" : "#579bfc";
                    const _bg = (_venceu ? "#e2445c" : _perto ? "#EBA13A" : "#579bfc") + "1A";
                    return <div style={{ marginTop: 3 }}><span style={{ fontSize: 10, fontWeight: 700, color: _cor, background: _bg, borderRadius: 8, padding: "2px 8px" }}>{(_venceu || _perto) ? "⚠️ " : ""}{_rot} · {_venceu ? "venceu há " + Math.abs(_dias) + "d" : "vence em " + _dias + "d"}</span></div>;
                  })()}
                </td>
                <td style={{ padding: "10px 14px", fontSize: 13, color: "var(--text-secondary)" }}>{c.cargo || "—"}</td>
                <td style={{ padding: "10px 14px", fontSize: 13, color: "var(--text-secondary)" }}>{c.departamento || "—"}</td>
                <td style={{ padding: "10px 14px", fontSize: 13, color: "var(--text-secondary)" }}>{fmtData(c.dataAdmissao)}</td>
                <td style={{ padding: "10px 14px", fontSize: 13, color: "var(--text-secondary)" }}>{tempoDeCasa(c.dataAdmissao)}</td>
                <td style={{ padding: "10px 14px", fontSize: 13, fontWeight: 700, color: "var(--text-primary)", textAlign: "right", whiteSpace: "nowrap" }}>{fmt(c.salario)}</td>
                <td style={{ padding: "10px 14px" }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: ST_COR[c.status], background: ST_COR[c.status] + "1A", borderRadius: 10, padding: "3px 10px" }}>{ST_LABEL[c.status] || c.status}</span>
                </td>
                <td style={{ padding: "10px 14px", textAlign: "center" }}>
                  <button onClick={() => setAberto(c)} style={btnG}>Abrir ficha</button>
                </td>
              </tr>
              </Fragment>
              );
            })}
            {!filtrados.length && <tr><td colSpan={8} style={{ padding: 30, textAlign: "center", color: "var(--text-muted)" }}>Nenhum colaborador.</td></tr>}
          </tbody>
        </table>
      </div>

      {aberto && <Ficha colab={aberto} onClose={() => setAberto(null)} onReload={carregar} setColab={setAberto} />}
      {novo && <ModalNovo onClose={() => setNovo(null)} onSalvar={salvarNovo} />}
    </div>
  );
}

function ModalNovo({ onClose, onSalvar }) {
  const [f, setF] = useState({ nome: "", cargo: "", departamento: "", tipoContrato: "CLT", dataAdmissao: "", status: "ativo" });
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  return (
    <Overlay onClose={onClose} width={460}>
      <h2 style={{ margin: "0 0 14px", fontSize: 17, fontWeight: 800, color: "var(--text-primary)" }}>Novo colaborador</h2>
      <div style={{ display: "grid", gap: 12 }}>
        <Campo label="Nome completo"><input value={f.nome} onChange={e => set("nome", e.target.value)} style={inp} autoFocus /></Campo>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <Campo label="Cargo"><input value={f.cargo} onChange={e => set("cargo", e.target.value)} style={inp} /></Campo>
          <Campo label="Departamento"><input value={f.departamento} onChange={e => set("departamento", e.target.value)} style={inp} /></Campo>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <Campo label="Tipo de contrato"><select value={f.tipoContrato} onChange={e => set("tipoContrato", e.target.value)} style={{ ...inp, appearance: "auto" }}>{["CLT", "PJ", "Estágio", "Temporário"].map(o => <option key={o}>{o}</option>)}</select></Campo>
          <Campo label="Data de admissão"><input type="date" value={f.dataAdmissao} onChange={e => set("dataAdmissao", e.target.value)} style={inp} /></Campo>
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 18 }}>
        <button onClick={onClose} style={btnG}>Cancelar</button>
        <button onClick={() => { if (!f.nome.trim()) return alert("Informe o nome."); onSalvar(f); }} style={btn()}>Criar</button>
      </div>
    </Overlay>
  );
}

function Overlay({ children, onClose, width = 720 }) {
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(16,24,40,.5)", display: "flex", alignItems: "flex-start", justifyContent: "center", zIndex: 1000, padding: "40px 16px", overflowY: "auto" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "var(--card-bg)", borderRadius: 16, padding: 24, width, maxWidth: "96vw", boxShadow: "0 24px 60px rgba(16,24,40,.3)" }}>{children}</div>
    </div>
  );
}

function Ficha({ colab, onClose, onReload, setColab }) {
  const [aba, setAba] = useState("dados");
  const abas = [["dados", "Dados"], ["documentos", `Documentos (${(colab.documentos || []).length})`], ["vales", `Vales (${(colab.vales || []).length})`], ["ferias", "Férias & Afastamentos"], ["reajustes", "Reajuste salarial"]];

  const recarregar = async () => { try { const { data } = await api.get("/colaboradores/" + colab._id); setColab(data); onReload(); } catch (e) {} };

  return (
    <Overlay onClose={onClose} width={760}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <h2 style={{ margin: 0, fontSize: 19, fontWeight: 800, color: "var(--text-primary)" }}>{colab.nome}</h2>
            <span style={{ fontSize: 11, fontWeight: 700, color: ST_COR[colab.status], background: ST_COR[colab.status] + "1A", borderRadius: 10, padding: "3px 10px" }}>{ST_LABEL[colab.status] || colab.status}</span>
          </div>
          <div style={{ fontSize: 12.5, color: "var(--text-muted)", marginTop: 3 }}>{colab.cargo || "—"} · {colab.departamento || "—"} · {tempoDeCasa(colab.dataAdmissao)} de casa</div>
        </div>
        <span onClick={onClose} style={{ cursor: "pointer", fontSize: 22, color: "var(--text-muted)", lineHeight: 1 }}>×</span>
      </div>

      <div style={{ display: "flex", gap: 4, borderBottom: "1px solid var(--border-color)", marginBottom: 18, overflowX: "auto" }}>
        {abas.map(([id, label]) => (
          <button key={id} onClick={() => setAba(id)} style={{ padding: "9px 14px", fontSize: 13, fontWeight: aba === id ? 700 : 500, cursor: "pointer", border: "none", background: "transparent", color: aba === id ? ORANGE : "var(--text-secondary)", borderBottom: aba === id ? "2px solid " + ORANGE : "2px solid transparent", marginBottom: -1, whiteSpace: "nowrap" }}>{label}</button>
        ))}
      </div>

      {aba === "dados" && <AbaDados colab={colab} onSaved={recarregar} />}
      {aba === "documentos" && <AbaDocumentos colab={colab} onChange={recarregar} />}
      {aba === "vales" && <AbaVales colab={colab} onChange={recarregar} />}
      {aba === "ferias" && <AbaFerias colab={colab} onChange={recarregar} />}
      {aba === "reajustes" && <AbaReajustes colab={colab} onChange={recarregar} />}
    </Overlay>
  );
}

function AbaDados({ colab, onSaved }) {
  const [f, setF] = useState(() => ({
    nome: colab.nome || "", cpf: colab.cpf || "", rg: colab.rg || "", dataNascimento: toInput(colab.dataNascimento), estadoCivil: colab.estadoCivil || "",
    cargo: colab.cargo || "", departamento: colab.departamento || "", tipoContrato: colab.tipoContrato || "CLT",
    dataAdmissao: toInput(colab.dataAdmissao), dataDesligamento: toInput(colab.dataDesligamento), status: colab.status || "ativo", salario: colab.salario || 0, motivoDesligamento: colab.motivoDesligamento || "",
    email: colab.email || "", telefone: colab.telefone || "",
    endereco: colab.endereco || {}, banco: colab.banco || {}, observacoes: colab.observacoes || "",
  }));
  const [salvando, setSalvando] = useState(false);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const setE = (k, v) => setF(p => ({ ...p, endereco: { ...p.endereco, [k]: v } }));
  const setB = (k, v) => setF(p => ({ ...p, banco: { ...p.banco, [k]: v } }));

  const salvar = async () => {
    setSalvando(true);
    try {
      const payload = { ...f, salario: Number(f.salario) || 0, dataNascimento: f.dataNascimento || null, dataAdmissao: f.dataAdmissao || null, dataDesligamento: f.dataDesligamento || null };
      await api.put("/colaboradores/" + colab._id, payload);
      await onSaved();
      alert("Dados salvos.");
    } catch (e) { alert("Erro ao salvar: " + ((e.response && e.response.data && e.response.data.erro) || e.message)); }
    setSalvando(false);
  };

  const G2 = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 };
  const G3 = { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 };
  return (
    <div style={{ display: "grid", gap: 14 }}>
      <Secao t="Pessoal" />
      <div style={G2}>
        <Campo label="Nome completo"><input value={f.nome} onChange={e => set("nome", e.target.value)} style={inp} /></Campo>
        <Campo label="E-mail"><input value={f.email} onChange={e => set("email", e.target.value)} style={inp} /></Campo>
      </div>
      <div style={G3}>
        <Campo label="CPF"><input value={f.cpf} onChange={e => set("cpf", e.target.value)} style={inp} /></Campo>
        <Campo label="RG"><input value={f.rg} onChange={e => set("rg", e.target.value)} style={inp} /></Campo>
        <Campo label="Nascimento"><input type="date" value={f.dataNascimento} onChange={e => set("dataNascimento", e.target.value)} style={inp} /></Campo>
      </div>
      <div style={G3}>
        <Campo label="Estado civil"><input value={f.estadoCivil} onChange={e => set("estadoCivil", e.target.value)} style={inp} /></Campo>
        <Campo label="Telefone"><input value={f.telefone} onChange={e => set("telefone", e.target.value)} style={inp} /></Campo>
        <div />
      </div>

      <Secao t="Contrato" />
      <div style={G3}>
        <Campo label="Cargo"><input value={f.cargo} onChange={e => set("cargo", e.target.value)} style={inp} /></Campo>
        <Campo label="Departamento"><input value={f.departamento} onChange={e => set("departamento", e.target.value)} style={inp} /></Campo>
        <Campo label="Tipo de contrato"><select value={f.tipoContrato} onChange={e => set("tipoContrato", e.target.value)} style={{ ...inp, appearance: "auto" }}>{["CLT", "PJ", "Estágio", "Temporário"].map(o => <option key={o}>{o}</option>)}</select></Campo>
      </div>
      <div style={G3}>
        <Campo label="Admissão"><input type="date" value={f.dataAdmissao} onChange={e => set("dataAdmissao", e.target.value)} style={inp} /></Campo>
        <Campo label="Status"><select value={f.status} onChange={e => set("status", e.target.value)} style={{ ...inp, appearance: "auto" }}>{["ativo", "afastado", "ferias", "desligado"].map(o => <option key={o} value={o}>{ST_LABEL[o]}</option>)}</select></Campo>
        <Campo label="Salário (R$)"><input type="number" value={f.salario} onChange={e => set("salario", e.target.value)} style={inp} /></Campo>
      </div>
      <Secao t="Desligamento" />
      <div style={G2}>
        <Campo label="Data de desligamento"><input type="date" value={f.dataDesligamento} onChange={e => set("dataDesligamento", e.target.value)} style={inp} /></Campo>
        <Campo label="Motivo"><input value={f.motivoDesligamento} onChange={e => set("motivoDesligamento", e.target.value)} placeholder="Ex: pedido de demissão, dispensa..." style={inp} /></Campo>
      </div>

      <Secao t="Endereço" />
      <div style={G3}>
        <Campo label="CEP"><input value={f.endereco.cep || ""} onChange={e => setE("cep", e.target.value)} style={inp} /></Campo>
        <Campo label="Cidade"><input value={f.endereco.cidade || ""} onChange={e => setE("cidade", e.target.value)} style={inp} /></Campo>
        <Campo label="UF"><input value={f.endereco.uf || ""} onChange={e => setE("uf", e.target.value)} style={inp} /></Campo>
      </div>
      <Campo label="Logradouro, número, bairro"><input value={f.endereco.logradouro || ""} onChange={e => setE("logradouro", e.target.value)} style={inp} /></Campo>

      <Secao t="Dados bancários" />
      <div style={G3}>
        <Campo label="Banco"><input value={f.banco.banco || ""} onChange={e => setB("banco", e.target.value)} style={inp} /></Campo>
        <Campo label="Agência"><input value={f.banco.agencia || ""} onChange={e => setB("agencia", e.target.value)} style={inp} /></Campo>
        <Campo label="Conta"><input value={f.banco.conta || ""} onChange={e => setB("conta", e.target.value)} style={inp} /></Campo>
      </div>
      <Campo label="Chave PIX"><input value={f.banco.pix || ""} onChange={e => setB("pix", e.target.value)} style={inp} /></Campo>

      <Campo label="Observações"><textarea value={f.observacoes} onChange={e => set("observacoes", e.target.value)} rows={2} style={{ ...inp, resize: "vertical" }} /></Campo>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button onClick={salvar} disabled={salvando} style={{ ...btn(), opacity: salvando ? 0.6 : 1 }}>{salvando ? "Salvando..." : "Salvar dados"}</button>
      </div>
    </div>
  );
}
function Secao({ t }) { return <div style={{ fontSize: 12, fontWeight: 800, color: ORANGE, textTransform: "uppercase", letterSpacing: ".05em", borderBottom: "1px solid var(--border-color)", paddingBottom: 5 }}>{t}</div>; }

function AbaDocumentos({ colab, onChange }) {
  const [nome, setNome] = useState("");
  const [categoria, setCategoria] = useState("Documento");
  const [validade, setValidade] = useState("");
  const [enviando, setEnviando] = useState(false);
  const fileRef = useRef();
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);

  const enviar = async (file) => {
    if (!file) return;
    setEnviando(true);
    try {
      const fd = new FormData();
      fd.append("arquivo", file);
      fd.append("nome", nome || file.name);
      fd.append("categoria", categoria);
      if (validade) fd.append("validade", validade);
      await api.post(`/colaboradores/${colab._id}/documento`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setNome(""); setValidade("");
      await onChange();
    } catch (e) { alert("Erro ao enviar: " + ((e.response && e.response.data && e.response.data.erro) || e.message)); }
    setEnviando(false);
    if (fileRef.current) fileRef.current.value = "";
  };
  const excluir = async (i) => { if (!window.confirm("Remover este documento?")) return; try { await api.delete(`/colaboradores/${colab._id}/documento/${i}`); await onChange(); } catch (e) {} };

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto", gap: 10, alignItems: "end", marginBottom: 16, padding: 14, background: "var(--hover-bg)", borderRadius: 10 }}>
        <Campo label="Nome do documento"><input value={nome} onChange={e => setNome(e.target.value)} placeholder="Ex: Contrato CLT" style={inp} /></Campo>
        <Campo label="Categoria"><select value={categoria} onChange={e => setCategoria(e.target.value)} style={{ ...inp, appearance: "auto" }}>{["Documento", "RG/CPF", "Contrato", "ASO", "NR (segurança)", "Exame médico", "Comprovante", "Certificado", "Outro"].map(o => <option key={o}>{o}</option>)}</select></Campo>
        <Campo label="Validade (opcional)"><input type="date" value={validade} onChange={e => setValidade(e.target.value)} style={inp} /></Campo>
        <div>
          <input ref={fileRef} type="file" style={{ display: "none" }} onChange={e => enviar(e.target.files[0])} />
          <button onClick={() => fileRef.current && fileRef.current.click()} disabled={enviando} style={{ ...btn(), opacity: enviando ? 0.6 : 1 }}>{enviando ? "Enviando..." : "+ Anexar"}</button>
        </div>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        {(colab.documentos || []).map((d, i) => {
          const venc = d.validade ? new Date(d.validade) : null;
          const vencida = venc && venc < hoje;
          const proxima = venc && !vencida && venc < new Date(hoje.getTime() + 30 * 86400000);
          return (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", border: "1px solid var(--border-color)", borderRadius: 10, background: "var(--card-bg)" }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13.5, fontWeight: 700, color: "var(--text-primary)" }}>{d.nome}</div>
                <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{d.categoria}{d.validade ? " · vence " + fmtData(d.validade) : ""}</div>
              </div>
              {vencida && <span style={{ fontSize: 10.5, fontWeight: 700, color: "#e2445c", background: "#e2445c1A", borderRadius: 8, padding: "2px 8px" }}>Vencido</span>}
              {proxima && <span style={{ fontSize: 10.5, fontWeight: 700, color: "#EBA13A", background: "#EBA13A1A", borderRadius: 8, padding: "2px 8px" }}>Vence em breve</span>}
              <a href={API_ORIGIN + d.url} target="_blank" rel="noreferrer" style={{ ...btnG, textDecoration: "none" }}>Abrir</a>
              <button onClick={() => excluir(i)} style={{ ...btnG, color: "#e2445c" }}>Excluir</button>
            </div>
          );
        })}
        {!(colab.documentos || []).length && <div style={{ padding: 20, textAlign: "center", color: "var(--text-muted)", fontSize: 13 }}>Nenhum documento anexado.</div>}
      </div>
    </div>
  );
}

function AbaVales({ colab, onChange }) {
  const hojeISO = new Date().toISOString().slice(0, 10);
  const [f, setF] = useState({ data: hojeISO, competencia: hojeISO.slice(0, 7), tipo: "adiantamento", valor: "", descricao: "" });
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const add = async () => {
    if (!Number(f.valor)) return alert("Informe o valor.");
    try { await api.post(`/colaboradores/${colab._id}/vale`, { ...f, valor: Number(f.valor) }); setF({ ...f, valor: "", descricao: "" }); await onChange(); }
    catch (e) { alert("Erro: " + ((e.response && e.response.data && e.response.data.erro) || e.message)); }
  };
  const excluir = async (i) => { if (!window.confirm("Remover este lançamento?")) return; try { await api.delete(`/colaboradores/${colab._id}/vale/${i}`); await onChange(); } catch (e) {} };
  const total = (colab.vales || []).reduce((a, v) => a + Number(v.valor || 0), 0);

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1.4fr auto", gap: 10, alignItems: "end", marginBottom: 16, padding: 14, background: "var(--hover-bg)", borderRadius: 10 }}>
        <Campo label="Tipo"><select value={f.tipo} onChange={e => set("tipo", e.target.value)} style={{ ...inp, appearance: "auto" }}>{["adiantamento", "vale-transporte", "vale-refeição", "desconto", "bônus", "outro"].map(o => <option key={o}>{o}</option>)}</select></Campo>
        <Campo label="Valor (R$)"><input type="number" value={f.valor} onChange={e => set("valor", e.target.value)} style={inp} /></Campo>
        <Campo label="Descrição"><input value={f.descricao} onChange={e => set("descricao", e.target.value)} placeholder="Opcional" style={inp} /></Campo>
        <button onClick={add} style={btn()}>+ Lançar</button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: 10, marginBottom: 12 }}>
        <Campo label="Data"><input type="date" value={f.data} onChange={e => set("data", e.target.value)} style={inp} /></Campo>
        <Campo label="Competência (mês)"><input type="month" value={f.competencia} onChange={e => set("competencia", e.target.value)} style={inp} /></Campo>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        {(colab.vales || []).map((v, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", border: "1px solid var(--border-color)", borderRadius: 10, background: "var(--card-bg)" }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text-primary)", textTransform: "capitalize" }}>{v.tipo}{v.descricao ? " · " + v.descricao : ""}</div>
              <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{fmtData(v.data)}{v.competencia ? " · comp. " + v.competencia : ""}</div>
            </div>
            <span style={{ fontSize: 13.5, fontWeight: 800, color: v.tipo === "desconto" ? "#e2445c" : "#1D9E75" }}>{v.tipo === "desconto" ? "- " : ""}{fmt(v.valor)}</span>
            <button onClick={() => excluir(i)} style={{ ...btnG, color: "#e2445c" }}>Excluir</button>
          </div>
        ))}
        {!(colab.vales || []).length && <div style={{ padding: 20, textAlign: "center", color: "var(--text-muted)", fontSize: 13 }}>Nenhum vale/lançamento.</div>}
      </div>
      {(colab.vales || []).length > 0 && <div style={{ textAlign: "right", marginTop: 12, fontSize: 14, fontWeight: 800, color: "var(--text-primary)" }}>Total: {fmt(total)}</div>}
    </div>
  );
}

function AbaReajustes({ colab, onChange }) {
  const hojeISO = new Date().toISOString().slice(0, 10);
  const [novo, setNovo] = useState("");
  const [data, setData] = useState(hojeISO);
  const [motivo, setMotivo] = useState("");
  const atual = Number(colab.salario || 0);
  const nv = Number(novo) || 0;
  const pct = atual > 0 && nv > 0 ? Math.round(((nv - atual) / atual) * 10000) / 100 : 0;
  const aplicar = async () => {
    if (!nv) return alert("Informe o novo salario.");
    if (!window.confirm("Aplicar reajuste? O salario passara de " + fmt(atual) + " para " + fmt(nv) + ".")) return;
    try { await api.post(`/colaboradores/${colab._id}/reajuste`, { data, salarioNovo: nv, motivo }); setNovo(""); setMotivo(""); await onChange(); }
    catch (e) { alert("Erro: " + ((e.response && e.response.data && e.response.data.erro) || e.message)); }
  };
  const excluir = async (i) => { if (!window.confirm("Remover este registro? (nao altera o salario atual)")) return; try { await api.delete(`/colaboradores/${colab._id}/reajuste/${i}`); await onChange(); } catch (e) {} };
  const hist = [...(colab.reajustes || [])].reverse();
  return (
    <div>
      <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 160, padding: "14px 16px", borderRadius: 12, background: "var(--card-bg)", border: "1px solid var(--border-color)" }}>
          <div style={{ fontSize: 11.5, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".04em" }}>Salario atual</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: "#1D9E75", marginTop: 2 }}>{fmt(atual)}</div>
        </div>
        <div style={{ flex: 1, minWidth: 160, padding: "14px 16px", borderRadius: 12, background: "var(--card-bg)", border: "1px solid var(--border-color)" }}>
          <div style={{ fontSize: 11.5, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".04em" }}>Reajustes aplicados</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: "var(--text-primary)", marginTop: 2 }}>{(colab.reajustes || []).length}</div>
        </div>
      </div>
      <div style={{ padding: 16, background: "var(--hover-bg)", borderRadius: 12, marginBottom: 18 }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: ORANGE, textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 10 }}>Novo reajuste</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
          <Campo label="Data"><input type="date" value={data} onChange={e => setData(e.target.value)} style={inp} /></Campo>
          <Campo label="Novo salario (R$)"><input type="number" value={novo} onChange={e => setNovo(e.target.value)} placeholder={String(atual)} style={inp} /></Campo>
          <Campo label="Variacao"><div style={{ ...inp, display: "flex", alignItems: "center", fontWeight: 700, color: pct > 0 ? "#1D9E75" : pct < 0 ? "#e2445c" : "var(--text-muted)" }}>{nv ? (pct > 0 ? "+" : "") + pct + "%" : "—"}</div></Campo>
        </div>
        <Campo label="Motivo"><input value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Ex: dissidio do sindicato, promocao, merito" style={inp} /></Campo>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
          <button onClick={aplicar} style={btn()}>Aplicar reajuste</button>
        </div>
      </div>
      <div style={{ display: "grid", gap: 8 }}>
        {hist.map((r, idx) => { const i = (colab.reajustes || []).length - 1 - idx; const sobe = r.salarioNovo >= r.salarioAnterior; return (
          <div key={idx} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", border: "1px solid var(--border-color)", borderRadius: 10, background: "var(--card-bg)" }}>
            <div style={{ minWidth: 84, fontSize: 12, color: "var(--text-muted)" }}>{fmtData(r.data)}</div>
            <div style={{ flex: 1, fontSize: 13, color: "var(--text-primary)" }}>{fmt(r.salarioAnterior)} <span style={{ color: "var(--text-muted)" }}>→</span> <span style={{ fontWeight: 700 }}>{fmt(r.salarioNovo)}</span>{r.motivo ? <span style={{ fontSize: 11.5, color: "var(--text-muted)" }}> · {r.motivo}</span> : null}</div>
            <span style={{ fontSize: 11.5, fontWeight: 700, color: sobe ? "#1D9E75" : "#e2445c", background: (sobe ? "#1D9E75" : "#e2445c") + "18", borderRadius: 8, padding: "2px 8px" }}>{(r.percentual > 0 ? "+" : "") + r.percentual}%</span>
            <button onClick={() => excluir(i)} style={{ ...btnG, color: "#e2445c" }}>Excluir</button>
          </div>
        ); })}
        {!(colab.reajustes || []).length && <div style={{ padding: 20, textAlign: "center", color: "var(--text-muted)", fontSize: 13 }}>Nenhum reajuste registrado.</div>}
      </div>
    </div>
  );
}

function AbaFerias({ colab, onChange }) {
  const [fe, setFe] = useState({ inicio: "", fim: "", status: "agendada", obs: "" });
  const [af, setAf] = useState({ tipo: "Atestado", inicio: "", fim: "", motivo: "" });
  const dias = (a, b) => { if (!a || !b) return 0; const d = Math.round((new Date(b) - new Date(a)) / 86400000) + 1; return d > 0 ? d : 0; };

  const addFerias = async () => {
    if (!fe.inicio || !fe.fim) return alert("Informe início e fim.");
    try { await api.post(`/colaboradores/${colab._id}/ferias`, { ...fe, dias: dias(fe.inicio, fe.fim) }); setFe({ inicio: "", fim: "", status: "agendada", obs: "" }); await onChange(); }
    catch (e) { alert("Erro: " + ((e.response && e.response.data && e.response.data.erro) || e.message)); }
  };
  const delFerias = async (i) => { if (!window.confirm("Remover?")) return; try { await api.delete(`/colaboradores/${colab._id}/ferias/${i}`); await onChange(); } catch (e) {} };
  const addAf = async () => {
    if (!af.inicio) return alert("Informe a data de início.");
    try { await api.post(`/colaboradores/${colab._id}/afastamento`, af); setAf({ tipo: "Atestado", inicio: "", fim: "", motivo: "" }); await onChange(); }
    catch (e) { alert("Erro: " + ((e.response && e.response.data && e.response.data.erro) || e.message)); }
  };
  const delAf = async (i) => { if (!window.confirm("Remover?")) return; try { await api.delete(`/colaboradores/${colab._id}/afastamento/${i}`); await onChange(); } catch (e) {} };

  return (
    <div style={{ display: "grid", gap: 20 }}>
      <div>
        <Secao t="Férias" />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto", gap: 10, alignItems: "end", margin: "12px 0", padding: 14, background: "var(--hover-bg)", borderRadius: 10 }}>
          <Campo label="Início"><input type="date" value={fe.inicio} onChange={e => setFe(p => ({ ...p, inicio: e.target.value }))} style={inp} /></Campo>
          <Campo label="Fim"><input type="date" value={fe.fim} onChange={e => setFe(p => ({ ...p, fim: e.target.value }))} style={inp} /></Campo>
          <Campo label="Situação"><select value={fe.status} onChange={e => setFe(p => ({ ...p, status: e.target.value }))} style={{ ...inp, appearance: "auto" }}>{["agendada", "gozada", "vendida"].map(o => <option key={o}>{o}</option>)}</select></Campo>
          <button onClick={addFerias} style={btn()}>+ Add</button>
        </div>
        <div style={{ display: "grid", gap: 8 }}>
          {(colab.ferias || []).map((v, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "9px 14px", border: "1px solid var(--border-color)", borderRadius: 10 }}>
              <div style={{ flex: 1 }}><span style={{ fontSize: 13, fontWeight: 700, color: "var(--text-primary)" }}>{fmtData(v.inicio)} → {fmtData(v.fim)}</span> <span style={{ fontSize: 11, color: "var(--text-muted)" }}>· {v.dias} dia(s) · {v.status}</span></div>
              <button onClick={() => delFerias(i)} style={{ ...btnG, color: "#e2445c" }}>Excluir</button>
            </div>
          ))}
          {!(colab.ferias || []).length && <div style={{ padding: 14, textAlign: "center", color: "var(--text-muted)", fontSize: 12.5 }}>Nenhuma férias registrada.</div>}
        </div>
      </div>

      <div>
        <Secao t="Afastamentos" />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto", gap: 10, alignItems: "end", margin: "12px 0", padding: 14, background: "var(--hover-bg)", borderRadius: 10 }}>
          <Campo label="Tipo"><select value={af.tipo} onChange={e => setAf(p => ({ ...p, tipo: e.target.value }))} style={{ ...inp, appearance: "auto" }}>{["Atestado", "Licença médica", "Licença maternidade", "Licença paternidade", "INSS", "Outro"].map(o => <option key={o}>{o}</option>)}</select></Campo>
          <Campo label="Início"><input type="date" value={af.inicio} onChange={e => setAf(p => ({ ...p, inicio: e.target.value }))} style={inp} /></Campo>
          <Campo label="Fim"><input type="date" value={af.fim} onChange={e => setAf(p => ({ ...p, fim: e.target.value }))} style={inp} /></Campo>
          <button onClick={addAf} style={btn()}>+ Add</button>
        </div>
        <div style={{ display: "grid", gap: 8 }}>
          {(colab.afastamentos || []).map((v, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "9px 14px", border: "1px solid var(--border-color)", borderRadius: 10 }}>
              <div style={{ flex: 1 }}><span style={{ fontSize: 13, fontWeight: 700, color: "var(--text-primary)" }}>{v.tipo}</span> <span style={{ fontSize: 11, color: "var(--text-muted)" }}>· {fmtData(v.inicio)}{v.fim ? " → " + fmtData(v.fim) : ""}</span></div>
              <button onClick={() => delAf(i)} style={{ ...btnG, color: "#e2445c" }}>Excluir</button>
            </div>
          ))}
          {!(colab.afastamentos || []).length && <div style={{ padding: 14, textAlign: "center", color: "var(--text-muted)", fontSize: 12.5 }}>Nenhum afastamento registrado.</div>}
        </div>
      </div>
    </div>
  );
}
